import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArificialAllocationRequest } from 'src/app/core/models/transport-operation/arificial-allocation-request';
import { AutoAllocateRequest } from 'src/app/core/models/transport-operation/auto-allocation-request';
import { DeleteAllocationRequest } from 'src/app/core/models/transport-operation/delete-allocation-request';
import { InventorySerchRequest } from 'src/app/core/models/transport-operation/inventory-serch-request';
import { ManualAllocationDetailSearchParams } from 'src/app/core/models/transport-operation/manual-allocation-detail-search-params';
import { MOHeaderSearchParams } from 'src/app/core/models/transport-operation/mo-header-search-params';
import { UrgentMORequest } from 'src/app/core/models/transport-operation/urgent-mo-request';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManualAllocationService {
  constructor(private http: HttpClient) { }

  searchMOHeader(searchParams: MOHeaderSearchParams): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/searchMOHeader`;
    return this.http.post(url, searchParams);
  }

  searchMODetail(searchParams: ManualAllocationDetailSearchParams): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/searchMODetail`;
    return this.http.post(url, searchParams);
  }

  searchWMSInventory(searchParams: InventorySerchRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/searchWMSInventory`;
    return this.http.post(url, searchParams);
  }

  doWMSArificialAllocation(searchParams: ArificialAllocationRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/doWMSArificialAllocation`;
    return this.http.post(url, searchParams);
  }

  searchWMSAllocatedStock(searchParams: InventorySerchRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/searchWMSAllocatedStock`;
    return this.http.post(url, searchParams);
  }

  doWMSAutoAllocation(searchParams: AutoAllocateRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/doWMSAutoAllocation`;
    return this.http.post(url, searchParams);
  }

  doWMSUrgentMO(searchParams: UrgentMORequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/doWMSUrgentMO`;
    return this.http.post(url, searchParams);
  }

  doWMSDeleteAllocation(searchParams: DeleteAllocationRequest): Observable<any> {
    const url = `${environment.logisticsApiUrl}/manualAllocation/doWMSDeleteAllocation`;
    return this.http.post(url, searchParams);
  }
}
